import { AfterViewInit, Component, ElementRef, HostListener, OnInit, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthGuard } from '../../core/guard/auth.guard';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BreadcrumbService } from '../../core/service/breadcrumb.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit  {
  @ViewChild('searchInputRef') searchInputRef!: ElementRef;
  
  title = 'loginPage';
  mobileNumber: string = '';
  // otpInputs: string[] = Array(6).fill(''); // Array for 6 OTP input boxes
  otpInputs: string[] = ['', '', '', '', '', '']; // Initialize 6 OTP input boxes
  otpSent: boolean = false;
  timer: number = 120; // Timer in seconds
  interval: any;
  showErrors: boolean = false; // To trigger validation errors
  isShaking: boolean = false; // Flag for shake animation
  isMobile: boolean = false;
  otpInputValue: any;
  flipCard: boolean = false;
  showToast = false;
  triggerShredAnimation: boolean = false;
  strips: number[] = [];
  toastMessage: string = '';
  errmsg: string = '';
  errorverifyOTP: string = '';
  isOtpLoading:boolean=false;
  isOtpValidationLoading:boolean=false;
  options = {
    headers: new HttpHeaders().set('x-api-key', environment.x_api_key)
  };
  showSendBtn: boolean=false;

  currentScreen: 'login' | 'otp' = 'login'; // Determines which screen to show

  consentChecked: boolean = false;


  constructor(private route: Router, private authGuard: AuthGuard, private http: HttpClient,private breadcrumbService: BreadcrumbService,   private renderer: Renderer2,) { }


  ngOnInit(): void {
    this.checkScreenSize();
  }

  @HostListener('window:resize', [])
  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768; // Adjust the width as per your requirement
    console.log(this.isMobile);
  }

  enableSendBtn(event:any){
   
      this.showSendBtn=!this.showSendBtn;
    
  }

  validateOtp(): void {
    // Check if all boxes are filled
    const isValid = this.otpInputs.every((otp) => otp.trim() !== '');
    if (!isValid) {
      this.showErrors = true;
    } else {
      this.showErrors = false;
      const otp = this.otpInputs.join(''); // Combine the OTP values
      console.log('Entered OTP:', otp);
    }
  }
  // Reset validation when transitioning screens
  resetValidation() {
    this.showErrors = false;
    this.isShaking = false;
  }

  onInput(event: Event,type:string): void {
    this.errmsg='';
    this.errorverifyOTP='';
    
    const input = event.target as HTMLInputElement;
    console.log(input.value);
    input.value = input.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
    console.log(input.value);
    if(type === 'number'){
      this.mobileNumber=input.value;
    }
    else{
      this.otpInputValue=input.value;
      console.log(this.otpInputValue);
    }
  }

  // Send OTP logic
  sendOtp() {
    this.errmsg='';
    this.isOtpLoading=true;
    console.log(this.mobileNumber);
    if (!this.mobileNumber || this.mobileNumber.length < 10) {
      this.triggerError();
      this.isOtpLoading=false;
      return;
    }

    let body1 = new URLSearchParams();
    body1.set('client_id', environment.client_id);
    body1.set('client_secret', environment.client_secret);
    body1.set('grant_type', environment.grant_type);
    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    };

    this.http.post(environment.cognito_endpoint, body1.toString(), options).subscribe({
      next: (response) => {
        let authData:any = response;
        const headerConfig = {
          'x-api-key': environment.x_api_key,
          'Authorizer': authData.access_token,
        }
        console.log(this.mobileNumber);
        let body:any = {
          "I_TEL_NBR": '+1' + this.mobileNumber,
          "channel_type": "SMS"
        }
        // let headers={Headers:{'Access-Control-Allow-Origin':'*','x-api-key': environment.x_api_key}}
        this.http.post(environment.api_gateway_generateOTP, body,{ headers: new HttpHeaders(headerConfig) }).subscribe({
          next: (response) => {
            this.isOtpLoading=false;
            // Reset validation for OTP screen
            this.resetValidation();
            this.currentScreen='otp';
            this.otpInputs = Array(6).fill(''); // Clear OTP inputs
            this.showToastMessage('OTP sent to your mobile!', 4000, 2000);
    
            this.startTimer(); // Start the countdown timer
            // alert('OTP has been sent to your mobile number.');
            if (!this.isMobile) {
              this.flipCard = true;
              setTimeout(() => {
                this.flipCard = false; // Stop shake animation after 500ms
                this.otpSent = true; // Switch to OTP screen
              }, 300);
            }
            else {
              this.otpSent = true; // Switch to OTP screen
            }
          },
          error: (error:any) => {
            this.otpSent = false;
            this.isOtpLoading=false;
            this.errmsg = error.error['message'];
          }
        })
      },
      error: (error:any) => {
        console.log('errpr')
        this.isOtpLoading=false;
        this.errmsg = error.error['message'];
      }
    });
  



  }

  // Verify OTP logic
  verifyOtp(otpInputValue: any) {
    // console.log(otpInputValue.length,'line no 140');
    this.isOtpValidationLoading=true;
    // this.validateOtp();
    const otp = this.otpInputs.join(''); // Concatenate OTP digits
    if (otpInputValue == undefined || otpInputValue.length !== 6) {
      this.triggerError();
      this.isOtpValidationLoading=false;
      return;
    }
    else {
      this.showErrors = false;
      console.log(this.otpInputValue, otpInputValue.length);

      let body1 = new URLSearchParams();
      body1.set('client_id', environment.client_id);
      body1.set('client_secret', environment.client_secret);
      body1.set('grant_type', environment.grant_type);
      let options = {
        headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      };
  
      this.http.post(environment.cognito_endpoint, body1.toString(), options).subscribe({
        next: (response) => {
          let authData:any = response;
          const headerConfig = {
            'x-api-key': environment.x_api_key,
            'Authorizer': authData.access_token,
          }
          let body = {
            "I_TEL_NBR": '+1' + this.mobileNumber,
            "otp": this.otpInputValue
          }
          this.http.post(environment.api_gateway_validateOTP, body,{ headers: new HttpHeaders(headerConfig) }).subscribe({
            next: (response) => {
              let obj:any=response;
              console.log(obj,obj.N_DRVR_NAME,'line no 160');
              this.breadcrumbService.setDriverName(obj.N_DRVR_NAME);
              this.breadcrumbService.setAccidentID(obj.I_ACDNT_ID);
              this.isOtpValidationLoading=false;
              this.authGuard.authenticateUser(obj.I_DRDR_ID);
              // Success scenario
              this.route.navigate(['/report']);
            },
            error: (error) => {
              this.isOtpValidationLoading=false;
              this.errorverifyOTP = error.error['message'];
            }
          })    
        },
        error: (error) => {
          this.errmsg = 'Invalid token!';
        }
      });
    }
  }

  flipTheCard() {
    this.currentScreen='login';
    this.consentChecked=false;

    this.showSendBtn=false;
    if (!this.isMobile) {
      this.flipCard = true;
      setTimeout(() => {
        this.flipCard = false;
        this.otpSent = false;
        this.mobileNumber = ''; // Stop shake animation after 500ms
      }, 300);
    }
    else {
      this.otpSent = false;
      this.mobileNumber = '';
    }
  }

  // Trigger error animation and validation
  triggerError() {
    this.showErrors = true; // Enable validation messages
    this.isShaking = true; // Start shake animation
    setTimeout(() => {
      this.isShaking = false; // Stop shake animation after 500ms
    }, 500);
  }

  // Start OTP timer
  startTimer() {
    this.timer = 120; // Reset timer
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
      } else {
        clearInterval(this.interval);
      }
    }, 1000);
  }

  // Resend OTP
  resendOtp() {
    this.strips = Array.from({ length: 10 }, (_, i) => i);
    this.showToastMessage('OTP resent to your mobile!', 6500, 2000);
    this.resetValidation();
    this.startTimer();
  }

  showToastMessage(message: string, time: number, shredTime: number) {
    this.showToast = true;
    this.toastMessage = message;
    this.triggerShredAnimation = false;

    // Hide the toast message after 3 seconds
    setTimeout(() => {
      this.triggerShredAnimation = true;
    }, shredTime);

    // Hide the toast message after 3 seconds
    setTimeout(() => {
      this.showToast = false;
      this.toastMessage = '';
    }, time);
  }
}
